import { Xcross } from "@UI/components/icons/Xcross.tsx"
import styles from "./button.module.less"

export const ClearResultsButton = ({clickEvent}: {clickEvent: () => void}) => {
    return (
        <div className={styles.clearResultsButton} onClick={clickEvent}>
            <Xcross size={16} />
        </div>
    )
}